module.exports = __webpack_public_path__ + "static/media/scoli-shoulder-1f.072ca7bf.png";